import React from "react"
import { addInventory } from "services"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Checkbox } from "components"
import classes from "./InventoryRowCheckbox.module.scss"

const InventoryRowCheckbox = props => {
  const {
    food,
    option,
    stockManagement,
    setStockManagement
  } = props

  const i18n = useTranslation()[1]

  const handleCheckbox = async (checked) => {
    setStockManagement(checked)

    try {
      await addInventory(
        food._id,
        option._id,
        {
          quantity: 0,
          branchId: option.branchId,
          stockManagement: checked
        }
      )
    } catch (err) {
      console.log(err)
    }
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Checkbox
      checked={stockManagement}
      onChange={handleCheckbox}
      className={clsx(
        classes["checkbox"],
        isLtr && classes["checkbox-ltr"]
      )}
    />
  )
}

export default InventoryRowCheckbox